import { render, staticRenderFns } from "./AttachmentEditor.vue?vue&type=template&id=75f61b34&"
import script from "./AttachmentEditor.vue?vue&type=script&lang=js&"
export * from "./AttachmentEditor.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports